export default __webpack_public_path__ + "static/media/rounded-bus-2x.74a46bd8.webp";